module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('row', {
    staticClass: "loginForm"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }), _vm._v(" "), _c('contact-us', {
    staticClass: "col-sm-12"
  }), _vm._v(" "), _c('va-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    attrs: {
      "type": _vm.alertType,
      "dismissible": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.alertType === 'success') ? _c('i', {
    staticClass: "icon fa fa-check"
  }) : _c('i', {
    staticClass: "icon fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.error) + "\n     ")])]), _vm._v(" "), _c('va-box', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "title": "Site Authentication",
      "theme": "box-info",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteAuth.username),
      expression: "siteAuth.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.siteAuth.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.siteAuth, "username", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('va-button', {
    attrs: {
      "isBlock": false,
      "theme": "danger",
      "name": "Cancel",
      "align": "right"
    }
  }), _vm._v(" "), _c('va-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "isBlock": false,
      "theme": "success",
      "align": "right",
      "name": "Save"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveSiteAuth($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('va-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error2),
      expression: "error2"
    }],
    attrs: {
      "type": "danger",
      "dismissible": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('i', {
    staticClass: "icon fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.error2) + "\n     ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9509ffb6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Contactus.vue
// module id = 737
// module chunks = 0